import axios from 'axios';
import get from 'lodash.get';
import { from } from 'rxjs';

export const getShiptogetherAlerts = (page, pageSize) => {
  const params = {
    page,
    pageSize,
  };
  const request = axios.get('/alerts/shipTogether', { params }).then((response) => {
    return get(response, 'data', undefined);
  });

  const data$ = from(request);
  return data$;
};

export const dismissAlerts = (alertIds) => {
  const post = axios.post('/alerts/shipTogether/dismiss', alertIds).then((response) => response.data);

  const post$ = from(post);
  return post$;
};
